import type { GlobalThemeOverrides } from 'naive-ui'

/**
 * Marketplace theme — Flux by Cruip, adopted at the user’s request on 2026-10-13
 * (docs/v2/marketplace-design.md). Near-monochrome, pill radii, generous whitespace.
 *
 * Deliberately NOT the dashboard theme. The two are never mixed (CLAUDE.md rule 6).
 */
export const marketplaceTheme: GlobalThemeOverrides = {
  common: {
    primaryColor: '#0F0F10',
    primaryColorHover: '#26262A',
    primaryColorPressed: '#000000',
    // The type system's one ink at its three strengths (design/flux.scss), as solid colours on
    // white: headings, copy (70%), metadata (60%).
    textColorBase: '#111111',
    textColor1: '#111111',
    textColor2: '#585858',
    textColor3: '#6F6F6F',
    placeholderColor: '#68686C',
    bodyColor: '#F7F7F7',
    cardColor: '#FFFFFF',
    borderColor: '#DEDEDE',
    borderRadius: '6px',
    borderRadiusSmall: '4px',
    fontSize: '16px',
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  },
  Button: {
    border: '1px solid #171717',
    borderHover: '1px solid #111111',
    borderPressed: '1px solid #111111',
    borderFocus: '1px solid #171717',
    borderDisabled: '1px solid #DEDEDE',
    borderRadiusMedium: '6px',
    borderRadiusLarge: '6px',
    borderRadiusSmall: '6px',
    heightMedium: '40px',
    heightLarge: '40px',
    heightSmall: '32px',
    fontSizeMedium: '15px',
    fontSizeSmall: '14px',
    textColor: '#0F0F10',
    textColorHover: '#0F0F10',
    textColorPressed: '#0F0F10',
  },
  Card: {
    borderRadius: '6px',
    borderColor: '#DEDEDE',
    color: '#FFFFFF',
    textColor: '#626262',
    titleTextColor: '#111111',
  },
  Input: { borderRadius: '6px', heightMedium: '48px', fontSizeMedium: '16px' },
  InternalSelection: { borderRadius: '999px', heightMedium: '48px', fontSizeMedium: '16px' },
  Form: { labelTextColor: '#3A3A3D', labelFontSizeTopMedium: '14px' },
  Tag: { borderRadius: '999px' },
}
